import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that checks if a string value contains only whitespace.
 *
 * Returns an error if the control value is non-empty but contains only whitespace characters.
 * Empty values are allowed (use Validators.required separately if needed).
 *
 * @example
 * ```typescript
 * this.form = new FormGroup({
 *   name: new FormControl('', [
 *     Validators.required,
 *     noWhitespaceValidator()
 *   ])
 * });
 * ```
 *
 * @returns Validator function that returns { whitespace: true } if value is whitespace-only
 */
export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Allow null, undefined, or empty string
    if (value === null || value === undefined || value === '') {
      return null;
    }

    // Check if string contains only whitespace
    const isWhitespace = typeof value === 'string' && value.trim().length === 0;

    return isWhitespace ? { whitespace: true } : null;
  };
}
